<template>
    <b-modal title="Holding"  no-close-on-backdrop hide-footer size="xl" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="approveHolding()">
            <div  class="form-group row">
                <label  class="col-sm-2 col-form-label">বাংলায় নাম</label>
                <label  class="col-sm-3 col-form-label">: {{holding.bn_name}}</label>
                <div class="col-sm-2"></div>
                <label  class="col-sm-2 col-form-label">ইংরেজিতে নাম</label>
                <label  class="col-sm-3 col-form-label">: {{holding.en_name}}</label>
            </div>
            <div  class="form-group row">
                <label  class="col-sm-2 col-form-label">বাসার  নাম</label>
                <label  class="col-sm-3 col-form-label">: {{holding.home_name}}</label>
                <div class="col-sm-2"></div>
                <label  class="col-sm-2 col-form-label"> অ্যাড্রেস </label>
                <label  class="col-sm-3 col-form-label">: {{holding.address}}</label>
            </div>
<!--            <div  class="form-group row">-->
<!--                <label v-if="$user.type == 1" class="col-sm-2 col-form-label">ফাইল</label>-->
<!--                <div v-if="holding.status != 1 && $user.type == 1" class="col-sm-3">-->
<!--                    <input-->
<!--                            type="file"-->
<!--                            ref="ImageFile"-->
<!--                            class="file-input"-->
<!--                            v-on:change="imageChanged"-->
<!--                    />-->
<!--                    <p v-show="check"  style="color:red">* File is required</p>-->
<!--                </div>-->
<!--                <div v-if="holding.status != 0 && $user.type == 1" class="col-sm-3">-->
<!--                    <button @click="downloadFile(holding)" class="btn btn-sm btn-primary">Download <i class="fa fa-download" aria-hidden="true"></i></button>-->
<!--                </div>-->
<!--                <div v-if="$user.type == 1" class="col-sm-2"></div>-->
<!--                <label  class="col-sm-2 col-form-label">স্ট্যাটাস </label>-->
<!--                <label  class="col-sm-3 col-form-label">: <span v-if="holding.status == 0">পেন্ডিং</span><span v-if="holding.status == 1">অনুমোদিত</span><span v-if="holding.status == 2">বাতিল</span></label>-->
<!--            </div>-->
            <br>
            <div v-if="holding.status == 1 || $user.type == 2" class="form-group row">
                <div class="col-sm-12">
                    <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                </div>
            </div>
            <div  v-if="holding.status == 0 && $user.type == 1" class="form-group row">
                <div class="col-sm-12">
                    <input type="submit" value="Approve" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                    <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                </div>
            </div>

        </form>
    </b-modal>
</template>

<script>
    export default {
        data(){
            return{
                largeModal:false,
                addLoader: false,
                holding:'',
                check:false,
                addApplicationLoader:false,
            }
        },
        props:['type'],
        methods:{
            downloadFile(holding){
                // alert(data.file_url)
                window.open(holding.avatar_path)
            },
            openModal(holding){
                this.largeModal = true
                this.holding = holding
            },
            approveHolding()
            {
                this.$store.dispatch('APPROVE_HOLDING',this.holding.id)
            },
            close(){
                this.largeModal = false
            },

        }

    }
</script>

<style>

</style>
